import { translate } from "app/language/service"
import { APP_CONTEXTS } from "app/model"
import { getActiveAppContext, setActiveAppContext } from "app/tools/common"
import { IForm } from "form/model"
import { getFormChangesCount } from "./change"
import { getForm, notifyFormClosed, notifyFormOpened } from "./common"

export function getFormLeavePageMessage(): string | undefined {
  if (!getActiveAppContext()) {
    return
  }
  const form = getForm()
  if (form.context.isCreation || getFormChangesCount(form.changes) === 0) {
    return
  }
  return translate("form.leave.page")
}

export const createPageFormEffect = (
  form: IForm,
  currentContext: APP_CONTEXTS | null,
  toCheckContext: APP_CONTEXTS,
  isFirstRenderWithContext: React.MutableRefObject<boolean>
) => {
  if (currentContext !== toCheckContext) {
    setActiveAppContext(toCheckContext)
  } else if (isFirstRenderWithContext.current) {
    notifyFormOpened(form)
    isFirstRenderWithContext.current = false
  }
  return () => {
    if (currentContext === toCheckContext) {
      notifyFormClosed(form)
      setActiveAppContext(null)
    }
  }
}
